export default function BookAppointment() {
    return(
        <section>
            <iframe className="w-100 h-80" title="book appointment" src="https://app.nexhealth.com/appt/killeen_family_dentistry"></iframe>
        </section>
    );
}